(function boot(retry = 0) {
  const shippingZone = document.getElementById("shipping-zone");
  const cityInput    = document.getElementById("city-input");
  //const checkoutBtn  = document.querySelector("#checkout, button[name='checkout']");
  const checkoutBtn  = document.getElementById("checkout");
  const noteEl       = document.getElementById("cart-note");

  const suggestions   = document.getElementById("city-suggestions");
  const postalDisplay = document.getElementById("postal-display");
  const postalValue   = document.getElementById("postal-value");
  const intlMsg       = document.getElementById("intl-shipping-msg");
  const intlIdWrap    = document.getElementById("intl-id-wrap");
  const intlIdInput   = document.getElementById("intl-id");
  const intlIdError   = document.getElementById("intl-id-error");
  const cityWrap      = document.getElementById("srilanka-city-select");
  const zoneError     = document.getElementById("zone-error-msg");
  const cityError     = document.getElementById("city-error");
  const whatsappNumber = "94702000400";
  if (!shippingZone || !cityInput || !checkoutBtn || !noteEl) {
    if (retry < 20) return setTimeout(() => boot(retry + 1), 200);
    console.warn("⛔ Shipping elements not found.");
    return;
  }

  // Use your existing SL city → postal map (unchanged)
const slCities = {
  "Colombo 01": "100",
  "Colombo 02": "200",
  "Colombo 03": "300",
  "Colombo 04": "400",
  "Colombo 05": "500",
  "Colombo 06": "600",
  "Colombo 07": "700",
  "Colombo 08": "800",
  "Colombo 09": "900",
  "Colombo 10": "1000",
  "Colombo 11": "1100",
  "Colombo 12": "1200",
  "Colombo 13": "1300",
  "Colombo 14": "1400",
  "Colombo 15": "1500",
  "Akarawita": "10732",
  "Athurugiriya": "10150",
  "Avissawella": "10700",
  "Batawala": "10513",
  "Battaramulla": "10120",
  "Batugampola": "10526",
  "Bope": "10522",
  "Boralesgamuwa": "10290",
  "Dedigamuwa": "10656",
  "Dehiwala": "10350",
  "Deltara": "10302",
  "Habarakada": "10204",
  "Handapangoda": "10524",
  "Hanwella": "10650",
  "Hewainna": "10714",
  "Hiripitya": "10232",
  "Hokandara": "10118",
  "Homagama": "10200",
  "Horagala": "10502",
  "Kaduwela": "10640",
  "Kahawala": "10508",
  "Kalatuwawa": "10718",
  "Kiriwattuduwa": "10208",
  "Kolonnawa": "10600",
  "Kosgama": "10730",
  "Madapatha": "10306",
  "Maharagama": "10280",
  "Malabe": "10115",
  "Meegoda": "10504",
  "Moratuwa": "10400",
  "Mount Lavinia": "10370",
  "Mullegama": "10202",
  "Mulleriyawa New Town": "10620",
  "Napawela": "10704",
  "Nugegoda": "10250",
  "Padukka": "10500",
  "Pannipitiya": "10230",
  "Piliyandala": "10300",
  "Pitipana Homagama": "10206",
  "Polgasowita": "10320",
  "Puwakpitiya": "10712",
  "Ranala": "10654",
  "Siddamulla": "10304",
  "Sri Jayawardenapura": "10100",
  "Talawatugoda": "10116",
  "Tummodara": "10682",
  "Waga": "10680",
  "Watareka": "10511",
  "Akaragama": "11536",
  "Alawala": "11122",
  "Ambagaspitiya": "11052",
  "Ambepussa": "11212",
  "Andiambalama": "11558",
  "Attanagalla": "11120",
  "Badalgama": "11538",
  "Banduragoda": "11244",
  "Batuwatta": "11011",
  "Bemmulla": "11040",
  "Biyagama": "11650",
  "Biyagama IPZ": "11672",
  "Bokalagama": "11216",
  "Bollete (WP)": "11024",
  "Bopagama": "11134",
  "Buthpitiya": "11720",
  "Dagonna": "11524",
  "Danowita": "11896",
  "Debahera": "11889",
  "Dekatana": "11690",
  "Delgoda": "11700",
  "Delwagura": "11228",
  "Demalagama": "11692",
  "Demanhandiya": "11270",
  "Dewalapola": "11102",
  "Divulapitiya": "11250",
  "Divuldeniya": "11208",
  "Dompe": "11680",
  "Dunagaha": "11264",
  "Ekala": "11380",
  "Ellakkala": "11116",
  "Essella": "11108",
  "Gampaha": "11000",
  "Ganemulla": "11020",
  "GonawalaWP": "11630",
  "Heiyanthuduwa": "11618",
  "Henegama": "11715",
  "Hinatiyana Madawala": "11568",
  "Hiswella": "11734",
  "Horampella": "11564",
  "Hunumulla": "11262",
  "Ihala Madampella": "11265",
  "Imbulgoda": "11856",
  "Ja-Ela": "11350",
  "Kadawatha": "11850",
  "Kahatowita": "11144",
  "Kalagedihena": "11875",
  "Kaleliya": "11160",
  "Kaluaggala": "11224",
  "Kandana": "11320",
  "Kapugoda": "10662",
  "Katana": "11534",
  "Katunayake": "11450",
  "Katunayake Air Force Camp": "11440",
  "Katunayake(FTZ)": "11420",
  "Katuwellegama": "11526",
  "Kelaniya": "11600",
  "Kimbulapitiya": "11522",
  "Kirindiwela": "11730",
  "Kitalawalana": "11206",
  "Kitulwala": "11242",
  "Kochchikade": "11540",
  "Kotadeniyawa": "11232",
  "Kotugoda": "11390",
  "Kumbaloluwa": "11105",
  "Loluwagoda": "11204",
  "Lunugama": "11062",
  "Mabodale": "11114",
  "Madelgamuwa": "11033",
  "Makewita": "11358",
  "Makola": "11640",
  "Malwana": "11670",
  "Mandawala": "11061",
  "Marandagahamula": "11260",
  "Mellawagedara": "11234",
  "Minuwangoda": "11550",
  "Mirigama": "11200",
  "Mithirigala": "11742",
  "Muddaragama": "11112",
  "Mudungoda": "11056",
  "Naranwala": "11063",
  "Nawana": "11222",
  "Nedungamuwa": "11066",
  "Negombo": "11500",
  "Nikahetikanda": "11128",
  "Nittambuwa": "11880",
  "Niwandama": "11354",
  "Pallewela": "11150",
  "Pamunugama": "11370",
  "Pamunuwatta": "11214",
  "Pasyala": "11890",
  "Peliyagoda": "11830",
  "Pepiliyawala": "11741",
  "Pethiyagoda": "11043",
  "Polpithimukulana": "11324",
  "Pugoda": "10660",
  "Radawadunna": "11892",
  "Radawana": "11725",
  "Raddolugama": "11400",
  "Ragama": "11010",
  "Ruggahawila": "11142",
  "Rukmale": "11129",
  "Seeduwa": "11410",
  "Siyambalape": "11607",
  "Talahena": "11504",
  "Thimbirigaskatuwa": "11532",
  "Tittapattara": "10664",
  "Udathuthiripitiya": "11054",
  "Udugampola": "11030",
  "Uggalboda": "11034",
  "Urapola": "11126",
  "Uswetakeiyawa": "11328",
  "Veyangoda": "11100",
  "Walgammulla": "11146",
  "Walpita": "11226",
  "Walpola (WP)": "11012",
  "Wanaluwewa": "11068",
  "Wathurugama": "11724",
  "Watinapaha": "11104",
  "Wattala": "11300",
  "Weboda": "11858",
  "Wegowwa": "11562",
  "Weliveriya": "11710",
  "Weweldeniya": "11894",
  "Yakkala": "11870",
  "Yatiyana(WP)": "11566",
  "Agalawatta": "12200",
  "Alubomulla": "12524",
  "Alutgama": "12080",
  "Anguruwatota": "12320",
  "Baduraliya": "12230",
  "Bandaragama": "12530",
  "Bellana": "12224",
  "Beruwala": "12070",
  "Bolossagama": "12008",
  "Bombuwala": "12024",
  "Boralugoda": "12142",
  "Bulathsinhala": "12300",
  "Danawala Thiniyawala": "12148",
  "Delmella": "12304",
  "Dharga Town": "12090",
  "Diwalakada": "12308",
  "Dodangoda": "12020",
  "Dombagoda": "12416",
  "Galpatha": "12005",
  "Gamagoda": "12016",
  "Gonapola Junction": "12410",
  "Govinna": "12310",
  "Gurulubadda": "12236",
  "Halkandawila": "12055",
  "Haltota": "12538",
  "Halwala": "12118",
  "Halwatura": "12306",
  "Hedigalla Colony": "12234",
  "Horana": "12400",
  "lngiriya": "12440",
  "Ittapana": "12116",
  "Kalawila Kiranthidiya": "12078",
  "Kalutara": "12000",
  "Kananwila": "12418",
  "Kandanagama": "12428",
  "Kehelwatta": "12550",
  "Kelinkanda": "12218",
  "Kitulgoda": "12222",
  "Koholana": "12007",
  "Kuda Uduwa": "12426",
  "Maggona": "12060",
  "Mahagama": "12210",
  "Mahakalupahana": "12126",
  "Matugama": "12100",
  "Meegahatenna": "12130",
  "Meegama": "12094",
  "Millaniya": "12412",
  "Millewa": "12422",
  "Miwanapalana": "12424",
  "Molkawa": "12216",
  "Morapitiya": "12232",
  "Morontuduwa": "12564",
  "Nawattuduwa": "12106",
  "Neboda": "12030",
  "Padagoda": "12074",
  "Pahalahewessa": "12144",
  "Paiyagala": "12050",
  "Panadura": "12500",
  "Pannila": "12114",
  "Paragastota": "12414",
  "Paragoda": "12302",
  "Paraigama": "12122",
  "Pelanda": "12214",
  "Pelawatta": "12138",
  "Pokunuwita": "12404",
  "Polgampola": "12136",
  "Poruwedanda": "12432",
  "Remunagoda": "12009",
  "Tebuwana": "12025",
  "Uduwara": "12322",
  "Utumgama": "12127",
  "Veyangalla": "12204",
  "Wadduwa": "12560",
  "Walagedara": "12112",
  "Walallawita": "12134",
  "Waskaduwa": "12580",
  "Welipenna": "12108",
  "Welmilla Junction": "12534",
  "Yagirala": "12124",
  "Yatadolawatta": "12104",
  "Yatawara Junction": "12006",
  "Akurana": "20850",
  "Alawatugoda": "20140",
  "Aludeniya": "20062",
  "Ambagahapelessa": "20986",
  "Ambatenna": "20136",
  "Ampitiya": "20160",
  "Ankumbura": "20150",
  "Atabage": "20574",
  "Balana": "20308",
  "Bambaragahaela": "20644",
  "Barawardhana Oya": "20967",
  "Batagolladeniya": "20154",
  "Batugoda": "20132",
  "Batumulla": "20966",
  "Bawlana": "20218",
  "Bopana": "20932",
  "Danture": "20465",
  "Dedunupitiya": "20068",
  "Dekinda": "20658",
  "Deltota": "20430",
  "Dolapihilla": "20126",
  "Dolosbage": "20510",
  "Doluwa": "20532",
  "Doragamuwa": "20816",
  "Dunuwila": "20824",
  "Ekiriya": "20732",
  "Elamulla": "20742",
  "Etulgama": "20202",
  "Galaboda": "20664",
  "Galagedara": "20100",
  "Galaha": "20420",
  "Galhinna": "20152",
  "Gallellagama": "20095",
  "Gampola": "20500",
  "Gelioya": "20620",
  "Godamunna": "20214",
  "Gomagoda": "20184",
  "Gonagantenna": "20712",
  "Gonawalapatana": "20656",
  "Gunnepana": "20270",
  "Gurudeniya": "20189",
  "Halloluwa": "20032",
  "Handaganawa": "20984",
  "Handawalapitiya": "20438",
  "Handessa": "20480",
  "Hanguranketha": "20710",
  "Harankahawa": "20092",
  "Hasalaka": "20960",
  "Hataraliyadda": "20060",
  "Hewaheta": "20440",
  "Hindagala": "20414",
  "Hondiyadeniya": "20524",
  "Hunnasgiriya": "20948",
  "lhala Kobbekaduwa": "20042",
  "lllagolla": "20724",
  "Jambugahapitiya": "20822",
  "Kadugannawa": "20300",
  "Kahataliyadda": "20924",
  "Kalugala": "20926",
  "Kandy": "20000",
  "Kapuliyadde": "20206",
  "Karandagolla": "20738",
  "Katugastota": "20800",
  "Kengalla": "20186",
  "Ketakumbura": "20306",
  "Ketawala Leula": "20198",
  "Kiribathkumbura": "20442",
  "Kobonila": "20928",
  "Kolabissa": "20212",
  "Kolongoda": "20971",
  "Kulugammana": "20048",
  "Kumbukkandura": "20902",
  "Kumburegama": "20086",
  "Kundasale": "20168",
  "Leemagahakotuwa": "20482",
  "Lunuketiya Maditta": "20172",
  "Madawala Bazaar": "20260",
  "Madugalla": "20938",
  "Madulkele": "20840",
  "Mahadoraliyadda": "20945",
  "Mahamedagama": "20216",
  "Mailapitiya": "20702",
  "Makkanigama": "20828",
  "Makuldeniya": "20921",
  "Mandaram Nuwara": "20744",
  "Mapakanda": "20662",
  "Marassana": "20210",
  "Marymount Colony": "20714",
  "Maturata": "20748",
  "Mawatura": "20564",
  "Medamahanuwara": "20940",
  "Medawala Harispattuwa": "20120",
  "Meetalawa": "20512",
  "Megoda Kalugamuwa": "20409",
  "Menikdiwela": "20470",
  "Menikhinna": "20170",
  "Mimure": "20923",
  "Minigamuwa": "20109",
  "Minipe": "20983",
  "Murutalawa": "20232",
  "Muruthagahamulla": "20526",
  "Naranpanawa": "20176",
  "Nattarampotha": "20194",
  "Nawalapitiya": "20650",
  "Nillambe": "20418",
  "Nugaliyadda": "20204",
  "Nugawela": "20072",
  "Pallebowala": "20734",
  "Pallekotuwa": "20084",
  "Panvila": "20830",
  "Panwilatenna": "20544",
  "Paradeka": "20578",
  "Pasbage": "20654",
  "Pattitalawa": "20511",
  "Pattiya Watta": "20118",
  "Peradeniya": "20400",
  "Pilawala": "20196",
  "Pilimatalawa": "20450",
  "Poholiyadda": "20106",
  "Polgolla": "20250",
  "Pujapitiya": "20112",
  "Pupuressa": "20546",
  "Pussellawa": "20580",
  "Putuhapuwa": "20906",
  "Rajawella": "20180",
  "Rambukpitiya": "20676",
  "Rambukwella": "20128",
  "Rangala": "20922",
  "Rantembe": "20990",
  "Rathukohodigala": "20818",
  "Rikillagaskada": "20730",
  "Sangarajapura": "20044",
  "Senarathwela": "20904",
  "Talatuoya": "20200",
  "Tawalantenna": "20838",
  "Teldeniya": "20900",
  "Tennekumbura": "20166",
  "Uda Peradeniya": "20404",
  "Udahentenna": "20506",
  "Udahingulwala": "20094",
  "Udatalawinna": "20802",
  "Udawatta": "20722",
  "Udispattuwa": "20916",
  "Ududumbara": "20950",
  "Uduwa": "20052",
  "Uduwahinna": "20934",
  "Uduwela": "20164",
  "Ulapane": "20562",
  "Ulpothagama": "20965",
  "Unuwinna": "20708",
  "Velamboda": "20640",
  "Wattappola": "20454",
  "Wattegama": "20810",
  "Watagoda Harispattuwa": "20134",
  "Weligalla": "20610",
  "Weligampola": "20666",
  "Wendaruwa": "20914",
  "Weragantota": "20982",
  "Werapitya": "20908",
  "Werellagama": "20080",
  "Wettawa": "20108",
  "Wilanagama": "20142",
  "Yahalatenna": "20234",
  "Yatihalagala": "20034",
  "Akuramboda": "21142",
  "Alwatta": "21004",
  "Ambana": "21504",
  "Ataragallewa": "21512",
  "Bambaragaswewa": "21212",
  "Beligamuwa": "21214",
  "Dambulla": "21100",
  "Dankanda": "21032",
  "Devagiriya": "21552",
  "Dewahuwa": "21206",
  "Dullewa": "21054",
  "Dunkolawatta": "21046",
  "Dunuwilapitiya": "21538",
  "Elkaduwa": "21012",
  "Erawula Junction": "21108",
  "Etanawala": "21402",
  "Galewela": "21200",
  "Gammaduwa": "21068",
  "Gangala Puwakpitiya": "21404",
  "Handungamuwa": "21536",
  "Hattota Amuna": "21514",
  "lllukkumbura": "21406",
  "Imbulgolla": "21064",
  "Inamaluwa": "21124",
  "Kaikawala": "21066",
  "Kalundawa": "21112",
  "Kandalama": "21106",
  "Karagahinna": "21014",
  "Katudeniya": "21016",
  "Kavudupelella": "21072",
  "Kibissa": "21122",
  "Kiwula": "21042",
  "Kongahawela": "21500",
  "Laggala Pallegama": "21520",
  "Leliambe": "21008",
  "Lenadora": "21094",
  "Madawala Ulpotha": "21074",
  "Madipola": "21156",
  "Mahawela": "21140",
  "Mananwatta": "21144",
  "Maraka": "21554",
  "Matale": "21000",
  "Melipitiya": "21055",
  "Metihakka": "21062",
  "Millawana": "21154",
  "Muwandeniya": "21044",
  "Nalanda": "21082",
  "Naula": "21090",
  "Nugagolla": "21534",
  "Opalgala": "21076",
  "Ovilikanda": "21020",
  "Palapathwela": "21070",
  "Pallepola": "21152",
  "Perakanatta": "21532",
  "Pubbiliya": "21502",
  "Ranamuregama": "21524",
  "Rattota": "21400",
  "Selagama": "21058",
  "Sigiriya": "21120",
  "Talagoda Junction": "21506",
  "Talakiriyagama": "21116",
  "Udasgiriya": "21051",
  "Udatenna": "21006",
  "Ukuwela": "21300",
  "Wahacotte": "21160",
  "Walawela": "21048",
  "Wehigala": "21009",
  "Welangahawatte": "21408",
  "Wewalawewa": "21114",
  "Wilgamuwa": "21530",
  "Yatawatta": "21056",
  "Agarapathana": "22094",
  "Ambagamuwa Udabulathgama": "20678",
  "Ambatalawa": "20686",
  "Ambewela": "22216",
  "Bogawantalawa": "22060",
  "Bopattalawa": "22095",
  "Dagampitiya": "20684",
  "Dayagama Bazaar": "22096",
  "Dikoya": "22050",
  "Doragala": "20567",
  "Dunukedeniya": "22002",
  "Ginigathena": "20680",
  "Gonakele": "22226",
  "Haggala": "22208",
  "Halgranoya": "22240",
  "Hangarapitiya": "22044",
  "Hapugastalawa": "20668",
  "Harangalagama": "20669",
  "Harasbedda": "22262",
  "Hatton": "22000",
  "Hedunuwewa": "22024",
  "Hitigegama": "22046",
  "Kalaganwatta": "22282",
  "Kandapola": "22220",
  "Katukitula": "20588",
  "Keerthi Bandarapura": "22274",
  "Kelanigama": "20688",
  "Ketaboola": "20660",
  "Kotagala": "22080",
  "Kotmale": "20560",
  "Kottellena": "22040",
  "Kumbalgamuwa": "22272",
  "Kumbukwela": "22246",
  "Kurupanawela": "22252",
  "Labukele": "20592",
  "Laxapana": "22034",
  "Lindula": "22090",
  "Madulla": "22256",
  "Maldeniya": "22021",
  "Maskeliya": "22070",
  "Maswela": "20566",
  "Mipanawa": "22254",
  "Mipilimana": "22214",
  "Morahenagama": "22036",
  "Munwatta": "20752",
  "Nanuoya": "22150",
  "Nawathispane": "20670",
  "Nayapana Janapadaya": "20568",
  "Nildandahinna": "22280",
  "Nissanka Uyana": "22075",
  "Norwood": "22058",
  "Nuwara Eliya": "22200",
  "Padiyapelella": "20750",
  "Patana": "22012",
  "Pitawala": "20682",
  "Pundaluoya": "22120",
  "Ramboda": "20590",
  "Rozella": "22008",
  "Rupaha": "22245",
  "Ruwaneliya": "22212",
  "Santhipura": "22202",
  "Talawakele": "22100",
  "Teripeha": "22287",
  "Udamadura": "22285",
  "Udapussallawa": "22250",
  "Walapane": "22270",
  "Watagoda": "22110",
  "Watawala": "22010",
  "Widulipura": "22032",
  "Wijebahukanda": "22018",
  "Ampilanthurai": "30162",
  "Araipattai": "30150",
  "Ayithiyamalai": "30362",
  "Bakiella": "30206",
  "Batticaloa": "30000",
  "Cheddipalayam": "30194",
  "Chenkaladi": "30350",
  "Eravur": "30300",
  "Kalkudah": "30410",
  "Kallar": "30250",
  "Kaluwanchikudi": "30200",
  "Kaluwankemy": "30372",
  "Kannankudah": "30016",
  "Karadiyanaru": "30354",
  "Kathiraveli": "30456",
  "Kattankudi": "30100",
  "Kiran": "30394",
  "Kirankulam": "30159",
  "Koddaikallar": "30249",
  "Kokkaddichcholai": "30160",
  "Kurukkalmadam": "30192",
  "Mandur": "30220",
  "Mankemi": "30442",
  "Miravodai": "30426",
  "Murakottanchanai": "30392",
  "Navagirinagar": "30238",
  "Navatkadu": "30018",
  "Oddamavadi": "30420",
  "Panichankemi": "30444",
  "Pankudavely": "30352",
  "Periyaporativu": "30230",
  "Periyapullumalai": "30358",
  "Pillaiyaradi": "30022",
  "Punanai": "30428",
  "Puthukudiyiruppu": "42530",
  "Thannamunai": "30024",
  "Thettativu": "30196",
  "Thikkodai": "30236",
  "Thirupalugamam": "30234",
  "Thuraineelavanai": "30254",
  "Unnichchai": "30364",
  "Vakaneri": "30424",
  "Vakarai": "30450",
  "Valaichenai": "30400",
  "Vantharumoolai": "30376",
  "Vellavely": "30204",
  "Agbopura": "31304",
  "Buckmigama": "31028",
  "Chinabay": "31050",
  "Dehiwatte": "31226",
  "Echchilampattai": "31236",
  "Galmetiyawa": "31318",
  "Gomarankadawala": "31026",
  "Kaddaiparichchan": "31212",
  "Kanniya": "31032",
  "Kantalai": "31300",
  "Kantalai Sugar Factory": "31306",
  "Kiliveddy": "31220",
  "Kinniya": "31100",
  "Kuchchaveli": "31014",
  "Kumburupiddy": "31012",
  "Kurinchakemy": "31112",
  "Lankapatuna": "31234",
  "Mahadivulwewa": "31036",
  "Maharugiramam": "31106",
  "Mallikativu": "31224",
  "Mawadichenai": "31238",
  "Mullipothana": "31312",
  "Mutur": "31200",
  "Neelapola": "31228",
  "Nilaveli": "31010",
  "Pankulam": "31034",
  "Rottawewa": "31038",
  "Sampaltivu": "31006",
  "Sampur": "31216",
  "Serunuwara": "31232",
  "Seruwila": "31260",
  "Sirajnagar": "31314",
  "Somapura": "31222",
  "Tampalakamam": "31046",
  "Tiriyayi": "31016",
  "Toppur": "31250",
  "Trincomalee": "31000",
  "Vellamanal": "31053",
  "Wanela": "31308",
  "Addalaichenai": "32350",
  "Akkaraipattu": "32400",
  "Ampara": "32000",
  "Bakmitiyawa": "32024",
  "Central Camp": "32050",
  "Dadayamtalawa": "32046",
  "Damana": "32014",
  "Damanewela": "32126",
  "Deegawapiya": "32006",
  "Dehiattakandiya": "32150",
  "Devalahinda": "32038",
  "Digamadulla Weeragoda": "32008",
  "Dorakumbura": "32104",
  "Galapitagala": "32066",
  "Gonagolla": "32064",
  "Hingurana": "32010",
  "Hulannuge": "32514",
  "lmkkamam": "32450",
  "Kalmunai": "32300",
  "Kannakipuram": "32405",
  "Karativu": "32250",
  "Kekirihena": "32074",
  "Koknahara": "32035",
  "Kolamanthalawa": "32102",
  "Komari": "32418",
  "Lahugala": "32512",
  "Madawalalanda": "32016",
  "Mahanagapura": "32018",
  "Mahaoya": "32070",
  "Malwatta": "32198",
  "Mangalagama": "32069",
  "Marathamune": "32314",
  "Mawanagama": "32158",
  "Moragahapallama": "32012",
  "Namaloya": "32037",
  "Navithanveli": "32308",
  "Nawamedagama": "32120",
  "Nintavur": "32340",
  "Oluvil": "32360",
  "Padiyatalawa": "32100",
  "Pahalalanda": "32034",
  "Palamunai": "32354",
  "Panama": "32508",
  "Pannalagama": "32022",
  "Paragahakele": "32031",
  "Periyaneelavanai": "32316",
  "Polwaga Janapadaya": "32032",
  "Pottuvil": "32500",
  "Rajagalatenna": "32068",
  "Sainthamaruthu": "32280",
  "Samanthurai": "32200",
  "Serankada": "32101",
  "Siripura": "32155",
  "Siyambalawewa": "32048",
  "Tempitiya": "32072",
  "Thambiluvil": "32415",
  "Tirukovil": "32420",
  "Uhana": "32060",
  "Wadinagala": "32039",
  "Wanagamuwa": "32454",
  "Werunketagoda": "32062",
  "Allaipiddi": "40000",
  "Allaveddi": "40000",
  "Alvai": "40000",
  "Anaicoddai": "40000",
  "Analaitivu": "40000",
  "Atchuveli": "40000",
  "Chankanai": "40000",
  "Chavakachcheri": "40000",
  "Chullipuram": "40000",
  "Chundikuli": "40000",
  "Chunnakam": "40000",
  "Delft": "40000",
  "DelftWest": "40000",
  "Eluvaitivu": "40000",
  "Erlalai": "40000",
  "Jaffna": "40000",
  "Kaitadi": "40000",
  "Kankesanthurai": "40000",
  "Karainagar": "40000",
  "Karaveddi": "40000",
  "Kayts": "40000",
  "Kodikamam": "40000",
  "Kokuvil": "40000",
  "Kondavil": "40000",
  "Kopay": "40000",
  "Kudatanai": "40000",
  "llavalai": "40000",
  "Mallakam": "40000",
  "Manipay": "40000",
  "Mathagal": "40000",
  "Meesalai": "40000",
  "Mirusuvil": "40000",
  "Nagar Kovil": "40000",
  "Nainathivu": "40000",
  "Neervely": "40000",
  "Pandaterippu": "40000",
  "Point Pedro": "40000",
  "Pungudutivu": "40000",
  "Putur": "40000",
  "Sandilipay": "40000",
  "Sithankemy": "40000",
  "Tellippallai": "40000",
  "Thondamanaru": "40000",
  "Urumpirai": "40000",
  "Vaddukoddai": "40000",
  "Valvettithurai": "40000",
  "Vannarponnai": "40000",
  "Varany": "40000",
  "Vasavilan": "40000",
  "Velanai": "40000",
  "Kilinochchi": "43000",
  "Adampan": "41000",
  "Arippu": "41000",
  "Athimottai": "41000",
  "Chilavathurai": "41000",
  "Erukkalampiddy": "41000",
  "llluppaikadavai": "41000",
  "Madhu Church": "41000",
  "Madhu Road": "41000",
  "Mannar": "41000",
  "Marichchi Kaddi": "41000",
  "Murunkan": "41000",
  "Nanattan": "41000",
  "P.P.Potkemy": "41000",
  "Palampiddy": "41000",
  "Periyakunchikulam": "41000",
  "Periyamadhu": "41000",
  "Pesalai": "41000",
  "Talaimannar": "41000",
  "Temple": "41000",
  "Tharapuram": "41000",
  "Thiruketheeswaram Temple": "41000",
  "Uyilankulam": "41000",
  "Vaddakandal": "41000",
  "Vankalai": "41000",
  "Vellan Kulam": "41000",
  "Vidataltivu": "41000",
  "Mullativu": "42000",
  "Alampil": "42000",
  "Karuppaddamurippu": "42000",
  "Kokkilai": "42000",
  "Kokkuthuoduvai": "42000",
  "Mankulam": "42000",
  "Mullivaikkal": "42000",
  "Mulliyawalai": "42000",
  "Muthauyan Kaddakulam": "42000",
  "Naddan Kandal": "42000",
  "Odduchudan": "42000",
  "Puthuvedduvan": "42000",
  "Thunukkai": "42000",
  "Udayarkaddu": "42000",
  "Vavunakkulam": "42000",
  "Visvamadukulam": "42000",
  "Yogapuram": "42000",
  "Vavuniya": "43000",
  "Akkarayankulam": "43000",
  "Cheddikulam": "43000",
  "Chemamadukkulam": "43000",
  "Elephant Pass": "43000",
  "Eluthumadduval": "43000",
  "Iranai lluppaikulam": "43000",
  "Iranaitiv": "43000",
  "Kanagarayankulam": "43000",
  "Kanavil": "43000",
  "Kandavalai": "43000",
  "Kavutharimunai": "43000",
  "lyakachchi": "43000",
  "Mahakachchakodiya": "43000",
  "Mamaduwa": "43000",
  "Maraiyadithakulam": "43000",
  "Mulliyan": "43000",
  "Murasumoddai": "43000",
  "Nedunkemy": "43000",
  "Neriyakulam": "43000",
  "Omanthai": "43000",
  "Palamoddai": "43000",
  "Pallai": "43000",
  "Pallavarayankaddu": "43000",
  "Pampaimadu": "43000",
  "Paranthan": "43000",
  "Pavaikulam": "43000",
  "Periyathambanai": "43000",
  "Periyaulukkulam": "43000",
  "Purakari Nallur": "43000",
  "Ramanathapuram": "43000",
  "Sasthrikulankulam": "43000",
  "Sivapuram": "43000",
  "Skanthapuram": "43000",
  "Thalayadi": "43000",
  "Tharmapuram": "43000",
  "Uruthirapuram": "43000",
  "Vaddakachchi": "43000",
  "Vannerikkulam": "43000",
  "Varikkuttiyoor": "43000",
  "Veravil": "43000",
  "Vinayagapuram": "43000",
  "Andiyagala": "50112",
  "Angamuwa": "50248",
  "Anuradhapura": "50000",
  "Awukana": "50169",
  "Bogahawewa": "50566",
  "Dematawewa": "50356",
  "Dunumadalawa": "50214",
  "Dutuwewa": "50393",
  "Elayapattuwa": "50014",
  "Eppawala": "50260",
  "Etawatunuwewa": "50584",
  "Etaweeragollewa": "50518",
  "Galadivulwewa": "50210",
  "Galenbindunuwewa": "50390",
  "Galkadawala": "50006",
  "Galkiriyagama": "50120",
  "Galkulama": "50064",
  "Galnewa": "50170",
  "Gambirigaswewa": "50057",
  "Ganewalpola": "50142",
  "Gemunupura": "50224",
  "Getalawa": "50392",
  "Gnanikulama": "50036",
  "Gonahaddenawa": "50554",
  "Habarana": "50150",
  "Halmillawa Dambulla": "50124",
  "Halmillawetiya": "50552",
  "Hidogama": "50044",
  "Horawpatana": "50350",
  "Horiwila": "50222",
  "Hurigaswewa": "50176",
  "Hurulunikawewa": "50394",
  "lhala Halmillewa": "50262",
  "lhalagama": "50304",
  "lpologama": "50280",
  "Kagama": "50282",
  "Kahatagasdigiliya": "50320",
  "Kahatagollewa": "50562",
  "Kalakarambewa": "50288",
  "Kalankuttiya": "50174",
  "Kalaoya": "50226",
  "Kalawedi Ulpotha": "50556",
  "Kallanchiya": "50454",
  "Kapugallawa": "50370",
  "Karagahawewa": "50232",
  "Katiyawa": "50261",
  "Kebithigollewa": "50550",
  "Kekirawa": "50100",
  "Kendewa": "50452",
  "Kiralogama": "50259",
  "Kirigalwewa": "50511",
  "Kitulhitiyawa": "50132",
  "Kurundankulama": "50062",
  "Labunoruwa": "50088",
  "Madatugama": "50130",
  "Maha Elagamuwa": "50126",
  "Mahabulankulama": "50196",
  "Mahailluppallama": "50270",
  "Mahakanadarawa": "50306",
  "Mahapothana": "50327",
  "Mahasenpura": "50574",
  "Mahawilachchiya": "50022",
  "Mailagaswewa": "50384",
  "Malwanagama": "50236",
  "Maneruwa": "50182",
  "Maradankadawala": "50080",
  "Maradankalla": "50308",
  "Medawachchiya": "50500",
  "Megodawewa": "50334",
  "Mihintale": "50300",
  "Morakewa": "50349",
  "Mulkiriyawa": "50324",
  "Muriyakadawala": "50344",
  "Nachchaduwa": "50046",
  "Namalpura": "50339",
  "Negampaha": "50180",
  "Nochchiyagama": "50200",
  "Padavi Maithripura": "50572",
  "Padavi Parakramapura": "50582",
  "Padavi Sripura": "50587",
  "Padavi Sritissapura": "50588",
  "Padaviya": "50570",
  "Padikaramaduwa": "50338",
  "Pahala Halmillewa": "50206",
  "Pahala Maragahawe": "50220",
  "Pahalagama": "50244",
  "Palagala": "50111",
  "Palugaswewa": "50144",
  "Pandukabayapura": "50448",
  "Pandulagama": "50029",
  "Parakumpura": "50326",
  "Parangiyawadiya": "50354",
  "Parasangahawewa": "50055",
  "Pemaduwa": "50020",
  "Perimiyankulama": "50004",
  "Pihimbiyagolewa": "50512",
  "Pubbogama": "50122",
  "Pulmoddai": "50567",
  "Punewa": "50506",
  "Rajanganaya": "50246",
  "Rambewa": "50450",
  "Rampathwila": "50386",
  "Ranorawa": "50212",
  "Rathmalgahawewa": "50514",
  "Saliyapura": "50008",
  "Seeppukulama": "50380",
  "Senapura": "50284",
  "Sivalakulama": "50068",
  "Siyambalewa": "50184",
  "Sravasthipura": "50042",
  "Talawa": "50230",
  "Tambuttegama": "50240",
  "Tammennawa": "50104",
  "Tantirimale": "50016",
  "Telhiriyawa": "50242",
  "Tirappane": "50072",
  "Tittagonewa": "50558",
  "Udunuwara Colony": "50207",
  "Upuldeniya": "50382",
  "Uttimaduwa": "50067",
  "Viharapalugama": "50012",
  "Vijithapura": "50110",
  "Wahalkada": "50564",
  "Wahamalgollewa": "50492",
  "Walagambahuwa": "50086",
  "Walahaviddawewa": "50516",
  "Welimuwapotana": "50358",
  "Welioya Project": "50586",
  "Alutwewa": "51014",
  "Aralaganwila": "51100",
  "Aselapura": "51072",
  "Attanakadawala": "51235",
  "Bakamuna": "51250",
  "Dalukana": "51092",
  "Damminna": "51106",
  "Dewagala": "51094",
  "Dimbulagala": "51031",
  "Divulankadawala": "51428",
  "Divuldamana": "51104",
  "Diyabeduma": "51225",
  "Diyasenpura": "51504",
  "Elahera": "51258",
  "Ellewewa": "51034",
  "Galamuna": "51416",
  "Galoya Junction": "51375",
  "Giritale": "51026",
  "Hansayapalama": "51098",
  "Hingurakdamana": "51408",
  "Hingurakgoda": "51400",
  "Jayanthipura": "51024",
  "Jayasiripura": "51246",
  "Kalingaela": "51002",
  "Kalukele Badanagala": "51037",
  "Kashyapapura": "51032",
  "Kawudulla": "51414",
  "Kawuduluwewa Stagell": "51514",
  "Kottapitiya": "51244",
  "Kumaragama": "51412",
  "Lakshauyana": "51006",
  "Maduruoya": "51108",
  "Maha Ambagaswewa": "51518",
  "Mahatalakolawewa": "51506",
  "Mahawela Sinhapura": "51076",
  "Mampitiya": "51090",
  "Medirigiriya": "51500",
  "Meegaswewa": "51508",
  "Minneriya": "51410",
  "Mutugala": "51064",
  "Nawasenapura": "51066",
  "Nelumwewa": "51096",
  "Nuwaragala": "51039",
  "Onegama": "51004",
  "Orubendi Siyambalawa": "51256",
  "Palugasdamana": "51046",
  "Parakramasamudraya": "51016",
  "Pelatiyawa": "51033",
  "Pimburattewa": "51102",
  "Polonnaruwa": "51000",
  "Pulastigama": "51050",
  "Sevanapitiya": "51062",
  "Sinhagama": "51378",
  "Sungavila": "51052",
  "Talpotha": "51044",
  "Tamankaduwa": "51089",
  "Tambala": "51049",
  "Unagalavehera": "51008",
  "Welikanda": "51070",
  "Wijayabapura": "51042",
  "Yodaela": "51422",
  "Yudaganawa": "51424",
  "Alahengama": "60416",
  "Alahitiyawa": "60182",
  "Alawatuwala": "60047",
  "Alawwa": "60280",
  "Ambakote": "60036",
  "Ambanpola": "60650",
  "Anhandiya": "60074",
  "Anukkane": "60214",
  "Aragoda": "60308",
  "Ataragalla": "60706",
  "Awulegama": "60462",
  "Balalla": "60604",
  "Bamunukotuwa": "60347",
  "Bandara Koswatta": "60424",
  "Bingiriya": "60450",
  "Bogamulla": "60107",
  "Bopitiya": "60155",
  "Boraluwewa": "60437",
  "Boyagane": "60027",
  "Bujjomuwa": "60291",
  "Buluwala": "60076",
  "Dambadeniya": "60130",
  "Daraluwa": "60174",
  "Deegalla": "60228",
  "Delwite": "60044",
  "Demataluwa": "60024",
  "Diddeniya": "60544",
  "Digannewa": "60485",
  "Divullegoda": "60472",
  "Dodangaslanda": "60530",
  "Doratiyawa": "60013",
  "Dummalasuriya": "60260",
  "Ehetuwewa": "60716",
  "Elibichchiya": "60156",
  "Embogama": "60718",
  "Etungahakotuwa": "60266",
  "Galgamuwa": "60700",
  "Gallewa": "60712",
  "Girathalana": "60752",
  "Giriulla": "60140",
  "Gokaralla": "60522",
  "Gonawila": "60170",
  "Halmillawewa": "60441",
  "Hengamuwa": "60414",
  "Hettipola": "60430",
  "Hilogama": "60486",
  "Hindagolla": "60034",
  "Hiriyala Lenawa": "60546",
  "Hiruwalpola": "60458",
  "Horambawa": "60181",
  "Hulogedara": "60474",
  "Hulugalla": "60477",
  "Hunupola": "60582",
  "lbbagamuwa": "60500",
  "Ihala Gomugomuwa": "60211",
  "lhala Kadigamuwa": "60238",
  "Ihala Katugampala": "60135",
  "llukhena": "60232",
  "Indulgodakanda": "60016",
  "Inguruwatta": "60064",
  "Iriyagolla": "60045",
  "Ithanawatta": "60025",
  "Kadigawa": "60492",
  "Kahapathwala": "60062",
  "Kalugamuwa": "60096",
  "Kanadeniyawala": "60054",
  "Kanattewewa": "60422",
  "Karagahagedara": "60106",
  "Karambe": "60602",
  "Katupota": "60350",
  "Kekunagolla": "60183",
  "Keppitiwalana": "60288",
  "Kimbulwanaoya": "60548",
  "Kirimetiyawa": "60184",
  "Kirindawa": "60212",
  "Kirindigalla": "60502",
  "Kithalawa": "60188",
  "Kobeigane": "60410",
  "Kohilagedara": "60028",
  "Konwewa": "60630",
  "Kosdeniya": "60356",
  "Kosgolla": "60029",
  "Kotawehera": "60483",
  "Kudagalgamuwa": "60003",
  "Kudakatnoruwa": "60754",
  "Kuliyapitiya": "60200",
  "Kumbukgeta": "60508",
  "Kumbukwewa": "60506",
  "Kuratihena": "60438",
  "Kurunegala": "60000",
  "Labbala": "60162",
  "Lonahettiya": "60108",
  "Madahapola": "60552",
  "Madakumburumulla": "60209",
  "Maduragoda": "60532",
  "Maeliya": "60512",
  "Magulagama": "60221",
  "Mahagalkadawala": "60731",
  "Mahagirilla": "60479",
  "Mahamukalanyaya": "60516",
  "Mahananneriya": "60724",
  "Maharachchimulla": "60286",
  "Maho": "60600",
  "Makulewa": "60714",
  "Makulpotha": "60514",
  "Makulwewa": "60578",
  "Malagane": "60404",
  "Mandapola": "60434",
  "Maspotha": "60344",
  "Mawathagama": "60060",
  "Medivawa": "60612",
  "Meegalawa": "60750",
  "Meetanwala": "60066",
  "Meewellawa": "60484",
  "Melsiripura": "60540",
  "Metikumbura": "60304",
  "Metiyagane": "60121",
  "Minhettiya": "60004",
  "Minuwangete": "60406",
  "Mirihanagama": "60408",
  "Monnekulama": "60495",
  "Moragane": "60354",
  "Moragollagama": "60640",
  "Morathiha": "60038",
  "Munamaldeniya": "60218",
  "Muruthenge": "60122",
  "Nabadewa": "60482",
  "Nagollagama": "60590",
  "Nagollagoda": "60226",
  "Nakkawatta": "60186",
  "Narammala": "60100",
  "Narangoda": "60152",
  "Nawatalwatta": "60292",
  "Nelliya": "60549",
  "Nikadalupotha": "60580",
  "Nikaweratiya": "60470",
  "Padeniya": "60461",
  "Padiwela": "60236",
  "Pahalagiribawa": "60735",
  "Pahamune": "60112",
  "Palukadawala": "60704",
  "Panadaragama": "60348",
  "Panagamuwa": "60052",
  "Panaliya": "60312",
  "Panliyadda": "60558",
  "Pannala": "60160",
  "Pansiyagama": "60554",
  "Periyakadneluwa": "60518",
  "Pihimbiya Ratmale": "60439",
  "Pihimbuwa": "60053",
  "Pilessa": "60058",
  "Polgahawela": "60300",
  "Polpitigama": "60620",
  "Pothuhera": "60330",
  "Puswelitenna": "60072",
  "Ridibendiella": "60606",
  "Ridigama": "60040",
  "Saliya Asokapura": "60736",
  "Sandalankawa": "60176",
  "Sirisetagama": "60478",
  "Siyambalangamuwa": "60646",
  "Solepura": "60737",
  "Solewewa": "60738",
  "Sunandapura": "60436",
  "Talawattegedara": "60306",
  "Tambutta": "60734",
  "Thalahitimulla": "60208",
  "Thalakolawewa": "60624",
  "Thalwita": "60572",
  "Thambagalla": "60584",
  "Tharana Udawela": "60227",
  "Thimbiriyawa": "60476",
  "Tisogama": "60453",
  "Torayaya": "60499",
  "Tuttiripitigama": "60426",
  "Udubaddawa": "60250",
  "Uhumiya": "60094",
  "Ulpotha Pallekele": "60622",
  "Usgala Siyabmalangamuwa": "60732",
  "Wadakada": "60318",
  "Wadumunnegedara": "60204",
  "Walakumburumulla": "60198",
  "Wannigama": "60465",
  "Wannikudawewa": "60721",
  "Wannilhalagama": "60722",
  "Wannirasnayakapura": "60490",
  "Warawewa": "60739",
  "Wariyapola": "60400",
  "Watuwatta": "60262",
  "Weerapokuna": "60454",
  "Welawa Juncton": "60464",
  "Welipennagahamulla": "60240",
  "Wellagala": "60402",
  "Wellarawa": "60456",
  "Wellawa": "60570",
  "Welpalla": "60206",
  "Wennoruwa": "60284",
  "Weuda": "60080",
  "Wewagama": "60195",
  "Yakwila": "60202",
  "Yatigaloluwa": "60314",
  "Adippala": "61012",
  "Ambakandawila": "61024",
  "Anamaduwa": "61500",
  "Andigama": "61508",
  "Angunawila": "61264",
  "Attawilluwa": "61328",
  "Bangadeniya": "61238",
  "Baranankattuwa": "61262",
  "Battuluoya": "61246",
  "Bujjampola": "61136",
  "Chilaw": "61000",
  "Dankotuwa": "61130",
  "Dunkannawa": "61192",
  "Eluwankulama": "61308",
  "Ettale": "61343",
  "Galmuruwa": "61233",
  "Ihala Kottaramulla": "61154",
  "Ihala Puliyankulama": "61316",
  "Ilippadeniya": "61018",
  "Inginimitiya": "61514",
  "Ismailpuram": "61302",
  "Kakkapalliya": "61236",
  "Kalladiya": "61534",
  "Kalpitiya": "61360",
  "Kandakuliya": "61358",
  "Karativponparappi": "61307",
  "Karawitagara": "61022",
  "Karuwalagaswewa": "61314",
  "Katuneriya": "61180",
  "Kirimundalama": "61362",
  "Koswatta": "61158",
  "Kottantivu": "61252",
  "Kottukachchiya": "61532",
  "Kudawewa": "61226",
  "Kumarakattuwa": "61032",
  "Kurinjanpitiya": "61356",
  "Kuruketiyawa": "61516",
  "Lihiriyagama": "61138",
  "Lunuwila": "61150",
  "Madampe": "61230",
  "Madurankuliya": "61270",
  "Mahakumbukkadawala": "61272",
  "Mahauswewa": "61512",
  "Mahawewa": "61220",
  "Mampuri": "61341",
  "Mangalaeliya": "61266",
  "Marawila": "61210",
  "Mudalakkuliya": "61506",
  "Mugunuwatawana": "61014",
  "Mukkutoduwawa": "61274",
  "Mundel": "61250",
  "Muttibendiwila": "61195",
  "Nainamadama": "61120",
  "Nalladarankattuwa": "61244",
  "Nattandiya": "61190",
  "Nawagattegama": "61520",
  "Norachcholai": "61342",
  "Palaviya": "61280",
  "Pallama": "61040",
  "Palliwasalturai": "61354",
  "Panirendawa": "61234",
  "Pothuwatawana": "61162",
  "Puttalam Cement Factory": "61326",
  "Puttalam": "61300",
  "Rajakadaluwa": "61242",
  "Saliyawewa Junction": "61324",
  "Serukele": "61042",
  "Sirambiadiya": "61312",
  "Siyambalagashene": "61504",
  "Tabbowa": "61322",
  "Talawila Church": "61344",
  "Toduwawa": "61224",
  "Udappuwa": "61004",
  "Uridyawa": "61502",
  "Vanathawilluwa": "61306",
  "Waikkal": "61110",
  "Watugahamulla": "61198",
  "Wennappuwa": "61170",
  "Wijeyakatupotha": "61006",
  "Wilpotha": "61008",
  "Yogiyana": "61144",
  "Akarella": "70082",
  "Atakalanpanna": "70294",
  "Ayagama": "70024",
  "Balangoda": "70100",
  "Batatota": "70504",
  "Belihuloya": "70140",
  "Bolthumbe": "70131",
  "Bomluwageaina": "70344",
  "Bulutota": "70346",
  "Dambuluwana": "70019",
  "Daugala": "70455",
  "Dela": "70042",
  "Delwala": "70046",
  "Demuwatha": "70332",
  "Dodampe": "70017",
  "Doloswalakanda": "70404",
  "Dumbara Manana": "70495",
  "Eheliyagoda": "70600",
  "Elapatha": "70032",
  "Ellagawa": "70492",
  "Ellaulla": "70552",
  "Ellawala": "70606",
  "Embilipitiya": "70200",
  "Eratna": "70506",
  "Erepola": "70602",
  "Gabbela": "70156",
  "Gallella": "70062",
  "Gangeyaya": "70195",
  "Gawaragiriya": "70026",
  "Getahetta": "70620",
  "Gillimale": "70002",
  "Godagampola": "70556",
  "Godakawela": "70160",
  "Gurubewilagama": "70136",
  "Halpe": "70145",
  "Halwinna": "70171",
  "Handagiriya": "70106",
  "Hapugastenna": "70164",
  "Hatangala": "70105",
  "Hatarabage": "70108",
  "Hidellana": "70012",
  "Hiramadagama": "70296",
  "Ihalagama": "70144",
  "lmbulpe": "70134",
  "Ittakanda": "70342",
  "Kahangama": "70016",
  "Kahawatta": "70150",
  "Kalawana": "70450",
  "Kaltota": "70122",
  "Karandana": "70488",
  "Karangoda": "70018",
  "Kella Junction": "70352",
  "Kiriella": "70480",
  "Kolambageara": "70180",
  "Kolombugama": "70403",
  "Kolonna": "70350",
  "Kudawa": "70005",
  "Kuruwita": "70500",
  "Lellopitiya": "70056",
  "Madalagama": "70158",
  "Mahawalatenna": "70112",
  "Makandura Sabara": "70298",
  "Malwala Junction": "70001",
  "Marapana": "70041",
  "Matuwagalagama": "70482",
  "Medagalatur": "70021",
  "Meddekanda": "70127",
  "Minipura Dumbara": "70494",
  "Mitipola": "70604",
  "Morahela": "70129",
  "Mulendiyawala": "70212",
  "Mulgama": "70117",
  "Nawalakanda": "70469",
  "NawinnaPinnakanda": "70165",
  "Niralagama": "70038",
  "Nivitigala": "70400",
  "Omalpe": "70215",
  "Opanayaka": "70080",
  "Padalangala": "70230",
  "Pallebedda": "70170",
  "Pambagolla": "70133",
  "Panamura": "70218",
  "Panapitiya": "70152",
  "Panapola": "70461",
  "Panawala": "70612",
  "Parakaduwa": "70550",
  "Pebotuwa": "70045",
  "Pelmadulla": "70070",
  "Pimbura": "70472",
  "Pinnawala": "70130",
  "Pothupitiya": "70338",
  "Rajawaka": "70116",
  "Rakwana": "70300",
  "Ranwala": "70162",
  "Rassagala": "70135",
  "Ratna Hangamuwa": "70036",
  "Ratnapura": "70000",
  "Samanalawewa": "70142",
  "Sri Palabaddala": "70004",
  "Sudagala": "70502",
  "Talakolahinna": "70101",
  "Tanjantenna": "70118",
  "Teppanawa": "70512",
  "Tunkama": "70205",
  "Udaha Hawupe": "70154",
  "Udakarawita": "70044",
  "Udaniriella": "70034",
  "Udawalawe": "70190",
  "Ullinduwawa": "70345",
  "Veddagala": "70459",
  "Vijeriya": "70348",
  "Waleboda": "70138",
  "Watapotha": "70408",
  "Waturawa": "70456",
  "Weligepola": "70104",
  "Welipathayaya": "70124",
  "Wewelwatta": "70066",
  "Wikiliya": "70114",
  "Alawatura": "71204",
  "Algama": "71607",
  "Alutnuwara": "71508",
  "Ambalakanda": "71546",
  "Ambulugala": "71503",
  "Amitirigala": "71320",
  "Ampagala": "71232",
  "Anhettigama": "71403",
  "Aranayaka": "71540",
  "Aruggammana": "71041",
  "Atale": "71363",
  "Batuwita": "71321",
  "Beligala(Sab)": "71044",
  "Berannawa": "71706",
  "Bopitiya (SAB)": "71612",
  "Boralankada": "71418",
  "Bossella": "71208",
  "Bulathkohupitiya": "71230",
  "Damunupola": "71034",
  "Debathgama": "71037",
  "Dedugala": "71237",
  "Deewala Pallegama": "71022",
  "Dehiowita": "71400",
  "Deldeniya": "71009",
  "Deloluwa": "71401",
  "Deraniyagala": "71430",
  "Dewalegama": "71050",
  "Dewanagala": "71527",
  "Dombemada": "71115",
  "Dorawaka": "71601",
  "Dunumala": "71605",
  "Galapitamada": "71603",
  "Galatara": "71505",
  "Galigamuwa Town": "71350",
  "Galpatha(Sab)": "71312",
  "Gantuna": "71222",
  "Gonagala": "71318",
  "Hakahinna": "71352",
  "Hakbellawaka": "71715",
  "Helamada": "71046",
  "Hemmatagama": "71530",
  "Hettimulla": "71210",
  "Hewadiwela": "71108",
  "Hingula": "71520",
  "Hinguralakanda": "71417",
  "Hiriwadunna": "71014",
  "Imbulana": "71313",
  "Imbulgasdeniya": "71055",
  "Kabagamuwa": "71202",
  "Kannattota": "71372",
  "Kegalle": "71000",
  "Kehelpannala": "71533",
  "Kitulgala": "71720",
  "Kondeniya": "71501",
  "Kotiyakumbura": "71370",
  "Lewangama": "71315",
  "Mahabage": "71722",
  "Mahapallegama": "71063",
  "Maharangalla": "71211",
  "Makehelwala": "71507",
  "Malalpola": "71704",
  "Maliboda": "71411",
  "Malmaduwa": "71325",
  "Mawanella": "71500",
  "Migastenna Sabara": "71716",
  "Miyanawita": "71432",
  "Molagoda": "71016",
  "Morontota": "71220",
  "Nelundeniya": "71060",
  "Niyadurupola": "71602",
  "Noori": "71407",
  "Parape": "71105",
  "Pattampitiya": "71130",
  "Pitagaldeniya": "71360",
  "Pothukoladeniya": "71039",
  "Rambukkana": "71100",
  "Ruwanwella": "71300",
  "Seaforth Colony": "71708",
  "Talgaspitiya": "71541",
  "Teligama": "71724",
  "Tholangamuwa": "71619",
  "Thotawella": "71106",
  "Tulhiriya": "71610",
  "Tuntota": "71062",
  "Udagaldeniya": "71113",
  "Udapotha": "71236",
  "Udumulla": "71521",
  "Undugoda": "71200",
  "Ussapitiya": "71510",
  "Wahakula": "71303",
  "Waharaka": "71304",
  "Warakapola": "71600",
  "Watura": "71035",
  "Weeoya": "71702",
  "Wegalla": "71234",
  "Welihelatenna": "71712",
  "Weragala": "71622",
  "Yatagama": "71116",
  "Yatapana": "71326",
  "Yatiyantota": "71700",
  "Yattogoda": "71029",
  "Agaliya": "80212",
  "Ahangama": "80650",
  "Ahungalla": "80562",
  "Akmeemana": "80090",
  "Aluthwala": "80332",
  "Ambalangoda": "80300",
  "Ampegama": "80204",
  "Amugoda": "80422",
  "Anangoda": "80044",
  "Angulugaha": "80122",
  "Ankokkawala": "80048",
  "Baddegama": "80200",
  "Balapitiya": "80550",
  "Banagala": "80143",
  "Batapola": "80320",
  "Bentota": "80500",
  "Boossa": "80270",
  "Dikkumbura": "80654",
  "Dodanduwa": "80250",
  "Ella Tanabaddegama": "80402",
  "Elpitiya": "80400",
  "Ethkandura": "80458",
  "Galle": "80000",
  "Ganegoda": "80440",
  "Ginimellagaha": "80220",
  "Gintota": "80280",
  "Godahena": "80302",
  "Gonagalpura": "80502",
  "Gonamulla Junction": "80054",
  "Gonapinuwala": "80230",
  "Habaraduwa": "80630",
  "Haburugala": "80506",
  "Halvitigala Colony": "80146",
  "Hawpe": "80132",
  "Hikkaduwa": "80240",
  "Hiniduma": "80080",
  "Hiyare": "80056",
  "Ihala Walpola": "80134",
  "lhalahewessa": "80432",
  "lmaduwa": "8013Und0",
  "lnduruwa": "80510",
  "Kahaduwa": "80460",
  "Kahawa": "80312",
  "Kananke Bazaar": "80136",
  "Karagoda": "80151",
  "Karandeniya": "80360",
  "Kosgoda": "80570",
  "Kottawagama": "80062",
  "Kuleegoda": "80328",
  "Magedara": "80152",
  "Malgalla Talangalla": "80144",
  "Mapalagama Central": "80116",
  "Mapalagama": "80112",
  "Mattaka": "80424",
  "Meda-Keembiya": "80092",
  "Meetiyagoda": "80330",
  "Miriswatta": "80508",
  "Nagoda": "80110",
  "Nakiyadeniya": "80064",
  "Nawadagala": "80416",
  "Neluwa": "80082",
  "Nindana": "80318",
  "Opatha": "80142",
  "Panangala": "80075",
  "Pannimulla Panagoda": "80086",
  "Parana ThanaYamgoda": "80114",
  "Pitigala": "80420",
  "Poddala": "80170",
  "Porawagama": "80408",
  "Rantotuwila": "80354",
  "Ratgama": "80260",
  "Talagampola": "80058",
  "Talgaspe": "80406",
  "Talgaswela": "80470",
  "Talpe": "80615",
  "Tawalama": "80148",
  "Tiranagama": "80244",
  "Udalamatta": "80108",
  "Udugama": "80070",
  "Uluvitike": "80168",
  "Unawatuna": "80600",
  "Unenwitiya": "80214",
  "Uragaha": "80352",
  "Uragasmanhandiya": "80350",
  "Wakwella": "80042",
  "Walahanduwa": "80046",
  "Wanchawela": "80120",
  "Wanduramba": "80100",
  "Warukandeniya": "80084",
  "Watugedara": "80340",
  "Weihena": "80216",
  "Yakkalamulla": "80150",
  "Yatalamatta": "80107",
  "Akuressa": "81400",
  "Alapaladeniya": "81475",
  "Aparekka": "81032",
  "Athuraliya": "81402",
  "Bengamuwa": "81614",
  "Beralapanathara": "81541",
  "Bopagoda": "81412",
  "Dampahala": "81612",
  "Deegala Lenama": "81452",
  "Deiyandara": "81320",
  "Dellawa": "81477",
  "Denagama": "81314",
  "Denipitiya": "81730",
  "Deniyaya": "81500",
  "Derangala": "81454",
  "Devinuwara (Dondra)": "81160",
  "Dikwella": "81200",
  "Diyagaha": "81038",
  "Diyalape": "81422",
  "Gandara": "81170",
  "Godapitiya": "81408",
  "Gomilamawarala": "81072",
  "Hakmana": "81300",
  "Handugala": "81326",
  "Horapawita": "81108",
  "Kalubowitiyana": "81478",
  "Kamburugamuwa": "81750",
  "Kamburupitiya": "81100",
  "Karagoda Uyangoda": "81082",
  "Karaputugala": "81106",
  "Karatota": "81308",
  "Kekanadurra": "81020",
  "Kiriweldola": "81514",
  "Kiriwelkele": "81456",
  "Kolawenigama": "81522",
  "Kotapola": "81480",
  "Kottegoda": "81180",
  "Lankagama": "81526",
  "Makandura": "81070",
  "Maliduwa": "81424",
  "Maramba": "81416",
  "Matara": "81000",
  "Mediripitiya": "81524",
  "Miella": "81312",
  "Mirissa": "81740",
  "Moragala Kirillapone": "81532",
  "Morawaka": "81470",
  "Mulatiyana Junction": "81071",
  "Nadugala": "81092",
  "Naimana": "81017",
  "Narawelpita": "81302",
  "Pahala Millawa": "81472",
  "Palatuwa": "81050",
  "Paragala": "81474",
  "Parapamulla": "81322",
  "Pasgoda": "81615",
  "Penetiyana": "81722",
  "Pitabeddara": "81450",
  "Pothdeniya": "81538",
  "Puhulwella": "81290",
  "Radawela": "81316",
  "Ransegoda": "81064",
  "Ratmale": "81030",
  "Rotumba": "81074",
  "Siyambalagoda": "81462",
  "Sultanagoda": "81051",
  "Telijjawila": "81060",
  "Thihagoda": "81280",
  "Urubokka": "81600",
  "Urugamuwa": "81230",
  "Urumutta": "81414",
  "Viharahena": "81508",
  "Walakanda": "81294",
  "Walasgala": "81220",
  "Waralla": "81479",
  "Weligama": "81700",
  "Wilpita": "81404",
  "Yatiyana": "81034",
  "Ambalantota": "82100",
  "Angunakolapelessa": "82220",
  "Bandagiriya Colony": "82005",
  "Barawakumbuka": "82110",
  "Beliatta": "82400",
  "Beragama": "82102",
  "Beralihela": "82618",
  "Bowalagama": "82458",
  "Bundala": "82002",
  "Ellagala": "82619",
  "Gangulandeniya": "82506",
  "Getamanna": "82420",
  "Goda Koggalla": "82401",
  "Gonagamuwa Uduwila": "82602",
  "Gonnoruwa": "82006",
  "Hakuruwela": "82248",
  "Hambantota": "82000",
  "Horewelagoda": "82456",
  "Hungama": "82120",
  "Ihala Beligalla": "82412",
  "Ittademaliya": "82462",
  "Julampitiya": "82252",
  "Kahandamodara": "82126",
  "Kariyamaditta": "82274",
  "Katuwana": "82500",
  "Kawantissapura": "82622",
  "Kirama": "82550",
  "Kirinda": "82614",
  "Lunama": "82108",
  "Lunugamwehera": "82634",
  "Magama": "82608",
  "Mahagalwewa": "82016",
  "Mamadala": "82109",
  "Medamulana": "82254",
  "Middeniya": "82270",
  "Migahajandur": "82014",
  "Modarawana": "82416",
  "Mulkirigala": "82242",
  "Nakulugamuwa": "82300",
  "Netolpitiya": "82135",
  "Nihiluwa": "82414",
  "Padawkema": "82636",
  "Pahala Andarawewa": "82008",
  "Pallekanda": "82454",
  "Rammalawarapitiya": "82554",
  "Ranakeliya": "82612",
  "Ranmuduwewa": "82018",
  "Ranna": "82125",
  "Ratmalwala": "82276",
  "RU/Ridiyagama": "82106",
  "Sooriyawewa Town": "82010",
  "Tangalla": "82200",
  "Tissamaharama": "82600",
  "Uda Gomadiya": "82504",
  "Udamattala": "82638",
  "Uswewa": "82278",
  "Vitharandeniya": "82232",
  "Walasmulla": "82450",
  "Weeraketiya": "82240",
  "Weerawila NewTown": "82615",
  "Weerawila": "82632",
  "Wekandawela": "82246",
  "Weligatta": "82004",
  "Yatigala": "82418",
  "Akkarasiyaya": "90166",
  "Aluketiyawa": "90736",
  "Aluttaramma": "90722",
  "Ambadandegama": "90108",
  "Ambagahawatta": "90326",
  "Ambagasdowa": "90300",
  "Amunumulla": "90204",
  "Arawa": "90017",
  "Arawakumbura": "90532",
  "Arawatta": "90712",
  "Atakiriya": "90542",
  "Badulla": "90000",
  "Baduluoya": "90019",
  "Ballaketuwa": "90092",
  "Bambarapana": "90322",
  "Bandarawela": "90100",
  "Beramada": "90066",
  "Bibilegama": "90502",
  "Bogahakumbura": "90354",
  "Boragas": "90362",
  "Boralanda": "90170",
  "Bowela": "90302",
  "Dambana": "90714",
  "Demodara": "90080",
  "Diganatenna": "90132",
  "Dikkapitiya": "90214",
  "Dimbulana": "90324",
  "Divulapelessa": "90726",
  "Diyatalawa": "90150",
  "Dulgolla": "90104",
  "Egodawela": "90013",
  "Ella": "90090",
  "Ettampitiya": "90140",
  "Galauda": "90065",
  "Galedanda": "90206",
  "Galporuyaya": "90752",
  "Gamewela": "90512",
  "Gawarawela": "90082",
  "Girandurukotte": "90750",
  "Godunna": "90067",
  "Gurutalawa": "90208",
  "Haldummulla": "90180",
  "Hali Ela": "90060",
  "Hangunnawa": "90224",
  "Haputale": "90160",
  "Hebarawa": "90724",
  "Heeloya": "90112",
  "Helahalpe": "90122",
  "Helapupula": "90094",
  "Hewanakumbura": "90358",
  "Hingurukaduwa": "90508",
  "Hopton": "90524",
  "Idalgashinna": "90167",
  "Jangulla": "90063",
  "Kahataruppa": "90052",
  "Kalubululanda": "90352",
  "Kalugahakandura": "90546",
  "Kalupahana": "90186",
  "Kandaketya": "90020",
  "Kandegedara": "90070",
  "Kandepuhulpola": "90356",
  "Kebillawela": "90102",
  "Kendagolla": "90048",
  "Keppetipola": "90350",
  "Keselpotha": "90738",
  "Ketawatta": "90016",
  "Kiriwanagama": "90184",
  "Koslanda": "90190",
  "Kotamuduna": "90506",
  "Kuruwitenna": "90728",
  "Kuttiyagolla": "90046",
  "Landewela": "90068",
  "Liyangahawela": "90106",
  "Lunugala": "90530",
  "Lunuwatta": "90310",
  "Madulsima": "90535",
  "Mahiyanganaya": "90700",
  "Makulella": "90114",
  "Malgoda": "90754",
  "Maliyadda": "90022",
  "Mapakadawewa": "90730",
  "Maspanna": "90328",
  "Maussagolla": "90582",
  "Medawela Udukinda": "90218",
  "Medawelagama": "90518",
  "Meegahakiula": "90015",
  "Metigahatenna": "90540",
  "Mirahawatta": "90134",
  "Miriyabedda": "90504",
  "Miyanakandura": "90584",
  "Namunukula": "90580",
  "Narangala": "90064",
  "Nelumgama": "90042",
  "Nikapotha": "90165",
  "Nugatalawa": "90216",
  "Ohiya": "90168",
  "Pahalarathkinda": "90756",
  "Pallekiruwa": "90534",
  "Passara": "90500",
  "Pathanewatta": "90071",
  "Pattiyagedara": "90138",
  "Pelagahatenna": "90522",
  "Perawella": "90222",
  "Pitamaruwa": "90544",
  "Pitapola": "90171",
  "Puhulpola": "90212",
  "Ratkarawwa": "90164",
  "Ridimaliyadda": "90704",
  "Rilpola": "90026",
  "Silmiyapura": "90364",
  "Sirimalgoda": "90044",
  "Sorabora Colony": "90718",
  "Soragune": "90183",
  "Soranatota": "90008",
  "Spring Valley": "90028",
  "Taldena": "90014",
  "Tennepanguwa": "90072",
  "Timbirigaspitiya": "90012",
  "Uduhawara": "90226",
  "Uraniya": "90702",
  "Uva Deegalla": "90062",
  "Uva Karandagolla": "90091",
  "Uva Mawelagama": "90192",
  "Uva Tenna": "90188",
  "Uva Tissapura": "90734",
  "Uva Uduwara": "90061",
  "Uvaparanagama": "90230",
  "Welimada": "90200",
  "Wewatta": "90716",
  "Wineethagama": "90034",
  "Yalagamuwa": "90329",
  "Yalwela": "90706",
  "Angunakolawewa": "91302",
  "Ayiwela": "91516",
  "Badalkumbura": "91070",
  "Baduluwela": "91058",
  "Bakinigahawela": "91554",
  "Balaharuwa": "91295",
  "Bibile": "91500",
  "Buddama": "91038",
  "Buttala": "91100",
  "Dambagalla": "91050",
  "Diyakobala": "91514",
  "Dombagahawela": "91010",
  "Ekamutugama": "70254",
  "Ekiriyankumbura": "91502",
  "Ethimalewewa": "91020",
  "Ettiliwewa": "91250",
  "Galabedda": "91008",
  "Hambegamuwa": "91308",
  "Hulandawa": "91004",
  "Inginiyagala": "91040",
  "Kandaudapanguwa": "91032",
  "Kandawinna": "91552",
  "Kataragama": "91400",
  "Kiriibbanwewa": "70252",
  "Kotagama": "91512",
  "Kotawehera Mankada": "91312",
  "Kotiyagala": "91024",
  "Kumbukkana": "91098",
  "Mahagama Colony": "70256",
  "Marawa": "91006",
  "Mariarawa": "91052",
  "Medagana": "91550",
  "Monaragala": "91000",
  "Moretuwegama": "91108",
  "Nakkala": "91003",
  "Nannapurawa": "91519",
  "Nelliyadda": "91042",
  "Nilgala": "91508",
  "Obbegoda": "91007",
  "Okkampitiya": "91060",
  "Pangura": "91002",
  "Pitakumbura": "91505",
  "Randeniya": "91204",
  "Ruwalwela": "91056",
  "Sella Kataragama": "91405",
  "Sewanagala": "70250",
  "Siyambalagune": "91202",
  "Siyambalanduwa": "91030",
  "Suriara": "91306",
  "Tanamalwila": "91300",
  "Uva Gangodagama": "91054",
  "Uva Kudaoya": "91298",
  "Uva Pelwatta": "91112",
  "Warunagama": "91198",
  "Wedikumbura": "91005",
  "Weherayaya Handapanagala": "91206",
  "Wellawaya": "91200",
  "Wilaoya": "91022",
  "Ratmalana": "10390",
  "Rajagiriya": "10100",
  "Angoda": "10620",
  "wellampitiya": "10600",
  "koralawella": "10400",
  "Ethulkotte": "10120",
  "Kesbewa": "10300",
  "kotte": "10100",
  "Wellawaththa": "600",
  "Hokandara south": "10116",
  "Nawala": "11222",
  "Ruckmalgama": "10230",
  "Gothatuwa": "10600",
  "Kotahena": "1300"
};
  // --- Utilities ---
  const debounce = (fn, ms = 250) => {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  };

  const saveNote = debounce((text) => {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: text || '' })
      }).catch(()=>{});
    } catch(e) {}
  }, 250);

  const validIntlId = (v) => {
    const s = (v || '').trim();
    return s.length >= 6 && s.length <= 24;
  };

  const composeNote = () => {
    const country = shippingZone.value;
    if (country === 'srilanka') {
      const city = (cityInput.value || '').trim();
      const postal = slCities[city] || '';
      return `Country: Sri Lanka${city ? ` | City: ${city}` : ''}${postal ? ` | Postal Code: ${postal}` : ''}`;
    }
    if (country === 'international') {
      const pid = (intlIdInput?.value || '').trim();
      return `Country: International${pid ? ` | Passport/ID: ${pid}` : ''}`;
    }
    return '';
  };

  const setNoteAndSave = () => {
    const text = composeNote();
    noteEl.value = text;
    saveNote(text);
  };

  // --- Main validation + UI ---
  function validateForm() {
    const country = shippingZone.value;
    const city    = (cityInput.value || '').trim();

    let valid = true;

    // Country required
    if (!country) {
      zoneError.style.display = "block";
      checkoutBtn.disabled = true;
      noteEl.value = '';
      return;
    } else {
      zoneError.style.display = "none";
    }

    if (country === 'international') {
      // Show intl UI; hide SL UI
      intlMsg.style.display    = "block";
      intlIdWrap.style.display = "block";
      cityWrap.style.display   = "none";
      postalDisplay.style.display = "none";

      const idOk = validIntlId(intlIdInput.value);
      intlIdError.style.display = idOk ? "none" : "block";
      intlIdInput.style.border = idOk ? "1px solid #ccc" : "1px solid #cc0000";

      valid = valid && idOk;
      checkoutBtn.disabled = !valid;
      checkoutBtn.textContent = "Continue to WhatsApp";
    } else if (country === 'srilanka') {
      // Show SL UI; hide intl UI
      intlMsg.style.display    = "none";
      intlIdWrap.style.display = "none";
      intlIdError.style.display = "none";

      cityWrap.style.display   = "block";

      if (slCities[city]) {
        postalValue.innerText = slCities[city];
        postalDisplay.style.display = "block";
        cityError.style.display = "none";
        checkoutBtn.disabled = false;
      } else {
        cityError.style.display = "block";
        postalDisplay.style.display = "none";
        checkoutBtn.disabled = true;
        valid = false;
      }
      checkoutBtn.textContent = "Check out";
    }

    // Compose + autosave the order note
    setNoteAndSave();
  }

  // --- Events ---
  shippingZone.addEventListener('change', () => {
    // Reset inputs on country change
    cityInput.value = '';
    suggestions.innerHTML = '';
    if (shippingZone.value === 'international') {
      intlIdInput.value = '';
      intlIdError.style.display = 'none';
      intlIdInput.style.border = '1px solid #ccc';
    }
    validateForm();
const country = shippingZone.value;
    console.log(country);
  });

  cityInput.addEventListener('input', () => {
    const val = cityInput.value.toLowerCase();
    suggestions.innerHTML = "";

    if (!val) {
      suggestions.style.display = "none";
      validateForm();
      return;
    }

    const matches = Object.keys(slCities).filter(c => c.toLowerCase().startsWith(val));
    matches.forEach(city => {
      const div = document.createElement("div");
      div.textContent = city;
      div.style.padding = "6px";
      div.style.cursor = "pointer";
      div.onclick = () => {
        cityInput.value = city;
        suggestions.style.display = "none";
        validateForm();
      };
      suggestions.appendChild(div);
    });
    suggestions.style.display = matches.length ? "block" : "none";
    validateForm();
  });

  intlIdInput.addEventListener('input', validateForm);

  async function getCartItems() {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    return cart.items.map(item => ({
      title: item.product_title,
      qty: item.quantity
    }));
  }

  // Block checkout when invalid; scroll to section
  checkoutBtn.addEventListener('click', async (e) => {
    const country = shippingZone.value;
    console.log("Country:", shippingZone.value);
    if (checkoutBtn.disabled) {
      e.preventDefault();
      validateForm();
      document.querySelector(".cart__shipping-section")?.scrollIntoView({ behavior: "smooth" });
      return;
    } 
    
    if (country == "international") {
      e.preventDefault();
      let message =
        "Hello, I would like to place an international order.\n\n";
      
      message += `*Customer Details*\n`;
      message += `${composeNote()}\n\n`;

      message += `*Cart Items:*\n`;
      
      const items = await getCartItems();

      items.forEach(item => {
        message += `• ${item.qty} × ${item.title}\n`;
      });



      window.open(
        `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`,
        "_blank"
      );
    } else {
      // Ensure freshest note right before leaving
      noteEl.value = composeNote();
      saveNote(noteEl.value);
    }
    console.log(country)
  });

  // Defaults + kick
  shippingZone.value = "srilanka"; // your original default
  validateForm();

  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) validateForm();
  });
  setTimeout(validateForm, 800);
})();